module.exports = __webpack_public_path__ + "img/vvv-black-with-text.73b408cc.png";